import { Box } from '@/components/Box/Box'
import css from './table.module.css'
import type { DetailedHTMLProps, TableHTMLAttributes } from 'react'
import cn from 'clsx'

export function Table({
    children,
    className,
    ...rest
}: DetailedHTMLProps<TableHTMLAttributes<HTMLTableElement>, HTMLTableElement>) {
    return (
        <Box className={css.tableContainer}>
            <table className={cn(css.articleTable, className)} {...rest}>
                {children}
            </table>
        </Box>
    )
}
